
import Vue from 'vue'
import Vuex from 'vuex'
import { VuexPersistence } from 'vuex-persist'

import UI from './modules/ui'
import User from './modules/user'
import TicketForm from './modules/ticket-form'

import { Department, UserRole } from '@/types/graphql'
import { PackageType } from '@/types/global'

Vue.use(Vuex)

export type StoreState = {
  UI: {
    uiModuleState: {
      isDrawerOpened: boolean
      isMobile: boolean
      navBarHeight: number
    }
  }
  User: {
    userState: {
      accessToken: string
      email: string
      name: string
      roles: UserRole[]
      contextDepartment: Maybe<Partial<Department>>
    }
  }
  TicketForm: {
    ticketFormState: {
      packageType?: PackageType
      packageNumber?: string
      subject?: string
      description?: string
      tag?: string
    }
  }
}

export const persistenceKey = 'vuex'

export const getPersistedState = (key = persistenceKey) => {
  const stringifiedOldPersistedState = localStorage.getItem(key)

  return stringifiedOldPersistedState
    ? JSON.parse(stringifiedOldPersistedState)
    : undefined
}

export const getPersistedVuexState = (key: string, userEmail?: string) => {
  // Get old persisted state
  const oldPersistedState = getPersistedState(key)

  if (oldPersistedState) {
    return {
      ...oldPersistedState[userEmail || oldPersistedState.lastUserEmail]
    }
  }
  return {}
}

// Declare empty store first, dynamically register all modules later.
export default new Vuex.Store({
  state: {} as StoreState,
  plugins: [new VuexPersistence({
    storage: localStorage,
    key: persistenceKey,
    reducer: (state: StoreState) => {
      // Get old persisted state
      const oldPersistedState = getPersistedState()

      // Get user email
      const userEmail = state.User.userState.email

      if (!userEmail) {
        return oldPersistedState
          ? {
            ...oldPersistedState,
            lastUserEmail: userEmail
          }
          : {}
      }

      return {
        ...oldPersistedState,
        lastUserEmail: userEmail,
        [userEmail]: {
          ...state
        }
      }
    },
    restoreState: (key: string) => {
      return getPersistedVuexState(key)
    }
  }).plugin],
  modules: { UI, User, TicketForm }
})
